<template>
	<field-wrapper v-bind="wrapper" @hook:mounted="watchField">
		<div class="dropdown">
			<select
				ref="field"
				:id="name"
				:name="name"
				v-model="model"
				:disabled="disabled"
			>
				<option v-for="o in options" :key="o.value" :value="o.value">{{
					o.label
				}}</option>
			</select>
		</div>
	</field-wrapper>
</template>

<script>
import FieldWrapper from '@/components/shared/FieldWrapper'
import field from '@/mixins/field'

export default {
	name: 'field-select',
	props: {
		options: Array
	},
	mixins: [field],
	components: {
		FieldWrapper
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
.dropdown {
	position: relative;
	background-color: $blue-98;

	&::after {
		content: '';
		position: absolute;
		width: 0.5rem;
		height: 0.5rem;
		border: 1px solid $blue-30;
		border-top: 0;
		border-left: 0;
		top: 50%;
		right: 0.75rem;
		transform: translateY(-75%) rotate(45deg);
	}
}
select {
	@extend %field;
	padding-right: 2rem;
}
</style>
